var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M661.333333 874.666667H170.666667c-46.933333 0-85.333333-38.4-85.333334-85.333334V234.666667c0-46.933333 38.4-85.333333 85.333334-85.333334h682.666666c46.933333 0 85.333333 38.4 85.333334 85.333334v362.666666c0 153.6-123.733333 277.333333-277.333334 277.333334z",
    fill: "#8CBCD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M746.666667 341.333333m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
    fill: "#B3DDF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.666667 341.333333L192 682.666667h469.333333z",
    fill: "#9AC9E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M661.333333 469.333333l-170.666666 213.333334h341.333333z",
    fill: "#B3DDF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.6 620.8l-59.733333-59.733333c-8.533333-8.533333-23.466667-8.533333-34.133334 0L896 588.8l93.866667 93.866667 27.733333-27.733334c8.533333-8.533333 8.533333-23.466667 0-34.133333z",
    fill: "#E57373"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M585.962667 899.562667L848.426667 637.12l93.525333 93.525333L679.466667 993.066667z",
    fill: "#FF9800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M989.866667 683.477333l-46.762667 46.762667-93.504-93.525333 46.762667-46.741334z",
    fill: "#B0BEC5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M586.666667 900.266667L554.666667 1024l123.733333-32z",
    fill: "#FFC107"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M569.6 960l-14.933333 64 64-14.933333z",
    fill: "#37474F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.81877de266b7f14c2b3350878b03af60.svg";
export { ForwardRef as ReactComponent };